import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/entries/entries-reducer-factory'
import { SET_CHAIN_CERTIFICATE } from '@/fleet-configuration/data-fleet/chain-certificate/chain-certificate-actions'

export const chainCertificateReducer = entriesReducerFactory(SET_CHAIN_CERTIFICATE)
